import { Tag } from '@cian/components';
import * as React from 'react';

import { IGeoNewbuildingTag } from '../../../../state/tags/definitions/geo/newbuilding';
import { TagNew } from '../../TagNew';

import { tagThemeSmall } from '../../tag_theme';

export interface IGeoNewobjectTagItemProps {
  tag: IGeoNewbuildingTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const GeoNewobjectTagItem = (props: IGeoNewobjectTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
